import React from 'react';

const PARTNERS = [
  'Legal Aid Ontario',
  'Ontario Courts',
  'Family Mediation Canada',
  'CLEO',
  'Government of Ontario'
];

const FOOTER_LINKS = {
  'About Good Parents Justice': [
    { label: 'Our mission', view: 'home' },
    { label: 'Guided pathways', view: 'home' },
    { label: 'Court guide', view: 'court-guide' }
  ],
  Resources: [
    { label: 'Ontario court forms', view: 'forms' },
    { label: 'Legal resources', view: 'resources' },
    { label: 'Find Help directory', view: 'directory' }
  ],
  'Terms and conditions': [
    { label: 'Privacy policy', view: 'privacy' },
    { label: 'Terms of use', view: 'terms' },
    { label: 'Legal disclaimer', view: 'disclaimer' }
  ]
};

export default function Footer({ setCurrentView }) {
  const navigate = (view) => {
    setCurrentView(view);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-blue-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="mb-8">
          <h2 className="text-xl font-bold mb-4">Good Parents Justice partners</h2>
          <div className="flex flex-wrap items-center gap-4">
            {PARTNERS.map((partner) => (
              <span key={partner} className="bg-white rounded p-3 text-blue-900 font-medium text-sm">
                {partner}
              </span>
            ))}
          </div>
        </div>

        <nav className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 text-left" aria-label="Footer navigation">
          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-bold mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <button
                      type="button"
                      onClick={() => navigate(link.view)}
                      className="text-blue-200 hover:text-white transition-colors text-sm text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="border-t border-blue-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <button
              type="button"
              onClick={() => navigate('home')}
              className="flex items-center gap-4 text-left hover:opacity-90 transition-opacity"
            >
              <span className="w-12 h-12 bg-orange-500 rounded flex items-center justify-center font-bold text-xl">GPJ</span>
              <span>
                <span className="font-bold block">Good Parents Justice</span>
                <span className="text-blue-200 text-sm">Ontario family court information and tools</span>
              </span>
            </button>

            <div className="text-center md:text-right max-w-2xl">
              <p className="text-blue-200 text-sm mb-2">
                This site contains general legal information for Ontario, Canada. It is not
                legal advice for a specific legal problem.
              </p>
              <p className="text-blue-300 text-xs">
                Good Parents Justice — independent legal information for Ontario families
                navigating family court
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
